<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import { debug, jobs } from '../../../stores/store';
    import { filter } from '../../../stores/filter';
    import SearchInput from '../../shared/SearchInput.svelte';

    import './JobOne.css';
    import HeaderSortableColumn from '../../shared/HeaderSortableColumn.svelte';

    export let jobFilter: ApiFilterBuilder;
    export let onFilterChange: () => void;
    export let simpleView: boolean = false;
</script>

<div class="order-element order-element-header" class:simple-view={simpleView}>
    <div class="checkbox">
        <Checkbox
            label=""
            checked={$jobs.selectMode === 'filtered'}
            onChange={v => {
                if ($jobs.selectMode === 'selected') {
                    $jobs.selectMode = 'filtered';
                    $jobs.selectedOrUnselected = [];
                } else {
                    $jobs.selectMode = 'selected';
                    $jobs.selectedOrUnselected = [];
                }
            }}
        />
    </div>
    <div class="address quick-search">
        <HeaderSortableColumn
            bind:jobFilter
            {onFilterChange}
            label=""
            className=""
            fieldName={['computed_address.city', 'computed_address.street_for_sorting']}
        />
        <SearchInput
            placeholder={$_('City_street_number')}
            query={$filter.jobsToBeCompleted.quickSearch}
            onChange={q => {
                $filter.jobsToBeCompleted.quickSearch = q;
            }}
            onKeyup={q => {
                $filter.jobsToBeCompleted.quickSearch = q;
            }}
            debounceTime={200}
        />
    </div>
    <div class="date">
        <HeaderSortableColumn
            bind:jobFilter
            {onFilterChange}
            label={$_('Realisation')}
            className=""
            fieldName="target_date"
        />
    </div>
    <div class="status">
        <HeaderSortableColumn
            bind:jobFilter
            {onFilterChange}
            label={$_('Status')}
            className=""
            fieldName="process_stage"
        />
    </div>
    <div class="other-2">
        <HeaderSortableColumn
            disabled={true}
            bind:jobFilter
            {onFilterChange}
            label={$_('Uwagi')}
            className=""
            fieldName=""
        />
    </div>
</div>
